module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show_language === true) ? _c('ul', {
    staticClass: "Language"
  }, _vm._l((_vm.languages), function(language) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.setLocale(language.code)
        }
      }
    }, [_c('img', {
      attrs: {
        "height": "25",
        "src": language.path
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(language.title))])])
  })) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-167c6c68!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/lang-selector.vue
// module id = 245
// module chunks = 1